(function () {
  'use strict';

  angular.module('app').component('bookingListActions', bookingListActions());

  function bookingListActions() {
    return {
      bindings: {
        showActions: '=',
        totalItems: '=',
        totalItemsSelected: '=',
        label: '@',
        updateItems: '&',
        hideDeleteButton: '=',
        permissions: '=',
      },
      controller: function () {},
      controllerAs: 'vm',
      templateUrl: './app/ajs/bookings/booking-list-actions/booking-list-actions.component.html',
    };
  }
})();
